import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs'; import DatePicker, { registerLocale } from "react-datepicker";
import { de } from "date-fns/locale";
import { subYears, format, parse, isValid } from "date-fns";
import { Turnstile } from "@marsidev/react-turnstile";

const ParkplatzStepForm = () => {

    const [step, setStep] = useState(1);

    const [selected, setSelected] = useState("tiefgarage");

    useEffect(() => {
        $(".select2").select2();
    }, []);

    let { title } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [headerModules, setHeaderModules] = useState(null);
    const [metaData, setMetaData] = useState(null);
    // const [siedlungen, setSiedlungen] = useState([]);

    const siedlungen = [
        {
            "id": 842,
            "documentId": "ymu1deytp3u2muejsj3upjlq",
            "createdAt": "2026-05-25T08:11:08.210Z",
            "updatedAt": "2026-06-18T12:10:16.001Z",
            "publishedAt": "2026-06-18T12:10:16.216Z",
            "slug": "siedlung-altstetten",
            "Page_Titel": "Altstetten, Zürich",
            "Ubersichtstext": "In einem familienfreundlichen Umfeld bieten 16 Häuser insgesamt 82 Wohnungen.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 911,
            "documentId": "st1j0rd408u804c75njgw1a1",
            "createdAt": "2026-05-25T09:34:51.660Z",
            "updatedAt": "2026-06-19T11:24:06.738Z",
            "publishedAt": "2026-06-19T11:24:06.982Z",
            "slug": "altstetterstrasse-zuerich",
            "Page_Titel": "Altstetterstrasse, Zürich",
            "Ubersichtstext": "Diese Liegenschaft bietet zwölf Wohnungen und sieben Gewerberäume in Altstetten. ",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 879,
            "documentId": "qygwsw88akizcpnl4tkntcpr",
            "createdAt": "2026-05-22T11:56:18.741Z",
            "updatedAt": "2026-06-19T08:42:46.486Z",
            "publishedAt": "2026-06-19T08:42:46.685Z",
            "slug": "am-suteracher",
            "Page_Titel": "Am Suteracher, Zürich",
            "Ubersichtstext": "Die 15 Wohnungen liegen auf einem Sockelgeschoss und bieten Balkone in erhöhter Lage. ",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 999,
            "documentId": "ijkzvx6xe5dghlnzidx2zo9d",
            "createdAt": "2026-05-22T08:07:05.864Z",
            "updatedAt": "2026-06-24T18:25:58.574Z",
            "publishedAt": "2026-06-24T18:25:58.761Z",
            "slug": "bockhornstrasse-5-11-zuerich",
            "Page_Titel": "Bockhornstrasse 5-11, Zürich",
            "Ubersichtstext": "Sanierung und Aufstockung in Holzbauweise schaffen zusätzlichen Wohnraum und setzen neue Massstäbe für nachhaltige Bestandesentwicklung.",
            "Page_Template": "Sanierungen"
        },
        {
            "id": 807,
            "documentId": "i8w1lmgutghq8sjfvmmww0y9",
            "createdAt": "2026-05-22T12:10:54.521Z",
            "updatedAt": "2026-06-17T12:21:47.808Z",
            "publishedAt": "2026-06-17T12:21:47.953Z",
            "slug": "breiteli-thalwil",
            "Page_Titel": "Breiteli, Thalwil",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 870,
            "documentId": "oua3w9cg7qqj51k02redh7hj",
            "createdAt": "2026-05-22T12:42:14.460Z",
            "updatedAt": "2026-06-19T08:08:08.879Z",
            "publishedAt": "2026-06-19T08:08:09.435Z",
            "slug": "breitwies-langnau-am-albis",
            "Page_Titel": "Breitwies, Langnau am Albis",
            "Ubersichtstext": "Die Siedlung Breitwies der Baugenossenschaft Zurlinden in Langnau am Albis verbindet naturnahes Wohnen mit einer guten Anbindung an das Dorfzentrum sowie an die Naherholungsräume entlang der Sihl.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 855,
            "documentId": "oc5q1cczaupo71lvod58mt1j",
            "createdAt": "2026-05-22T12:53:38.372Z",
            "updatedAt": "2026-06-18T13:00:09.493Z",
            "publishedAt": "2026-06-18T13:00:09.749Z",
            "slug": "breitwies-hoeflistrasse-langnau",
            "Page_Titel": "Breitwies- / Höflistrasse, Langnau ",
            "Ubersichtstext": "Die Anlage umfasst 96 Wohnungen für unterschiedliche Bedürfnisse. Zwischen den neun Häusern befinden sich weite Grünflächen, die ein Gefühl von Freiraum vermitteln.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 858,
            "documentId": "buyandcvtnsv5vfegbljqt21",
            "createdAt": "2026-05-22T13:06:12.389Z",
            "updatedAt": "2026-06-18T13:11:23.442Z",
            "publishedAt": "2026-06-18T13:11:23.684Z",
            "slug": "breitwiesstrasse-langnau-am-albis",
            "Page_Titel": "Breitwiesstrasse 31 + 33, Langnau am Albis",
            "Ubersichtstext": "In ruhiger Umgebung liegen zwei Wohnhäuser nahe der Sihl. Die 32 Wohnungen bieten ein Umfeld für Familien, ergänzt durch Spielplätze und grosszügigen Umschwung.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 809,
            "documentId": "upjb3gbxw7udxgvsvr65cq3y",
            "createdAt": "2026-05-22T12:11:36.745Z",
            "updatedAt": "2026-06-17T12:23:59.213Z",
            "publishedAt": "2026-06-17T12:23:59.361Z",
            "slug": "bueelhalde-oberrieden",
            "Page_Titel": "Büelhalde, Oberrieden",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 811,
            "documentId": "uzka3osm0e638h114q3ihdib",
            "createdAt": "2026-05-22T12:10:37.859Z",
            "updatedAt": "2026-06-17T12:27:41.208Z",
            "publishedAt": "2026-06-17T12:27:41.373Z",
            "slug": "dollikerstrasse-meilen",
            "Page_Titel": "Dollikerstrasse, Meilen",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 1006,
            "documentId": "k6f7y040se2ipmy4pe4imgav",
            "createdAt": "2026-06-11T06:53:59.291Z",
            "updatedAt": "2026-06-24T18:59:36.059Z",
            "publishedAt": "2026-06-24T18:59:36.219Z",
            "slug": "feldblumenstrasse",
            "Page_Titel": "Feldblumenstrasse",
            "Ubersichtstext": "Energetische Sanierung mit erneuerbarer Energieversorgung und zeitgemässer Wohnqualität für die kommenden Jahrzehnte.",
            "Page_Template": "Sanierungen"
        },
        {
            "id": 915,
            "documentId": "k3ejzy5l3p1inukeshq6uev8",
            "createdAt": "2026-05-22T13:11:37.436Z",
            "updatedAt": "2026-06-19T11:57:47.001Z",
            "publishedAt": "2026-06-19T11:57:47.234Z",
            "slug": "feldblumenstrasse-adliswil",
            "Page_Titel": "Feldblumenstrasse 6 + 8, Adliswil ",
            "Ubersichtstext": "Zwei Mehrfamilienhäuser in Adliswil bieten 21 Wohnungen mit Blick ins Sihltal.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 1026,
            "documentId": "o96w17jxuhseia53fcmzca0v",
            "createdAt": "2026-06-11T06:54:42.404Z",
            "updatedAt": "2026-07-01T12:34:11.038Z",
            "publishedAt": "2026-07-01T12:34:11.230Z",
            "slug": "friedhofstrasse",
            "Page_Titel": "Friedhofstrasse",
            "Ubersichtstext": "Nachhaltige Gebäudesanierung mit moderner Haustechnik, erneuerbaren Energien und einer umfassenden Aufwertung der Wohnungen.",
            "Page_Template": "Sanierungen"
        },
        {
            "id": 910,
            "documentId": "uu4be7s23y9k8b2yyf8tfbct",
            "createdAt": "2026-05-25T07:52:48.329Z",
            "updatedAt": "2026-06-19T11:07:47.747Z",
            "publishedAt": "2026-06-19T11:07:47.940Z",
            "slug": "friedhofstrasse-zuerich",
            "Page_Titel": "Friedhofstrasse 35 - 41, Zürich",
            "Ubersichtstext": "In einem familienfreundlichen Quartier liegen vier Wohnhäuser mit 40 Wohnungen.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 900,
            "documentId": "lh2o2a2isyn2fdki03sycdp0",
            "createdAt": "2026-05-22T07:36:03.088Z",
            "updatedAt": "2026-06-19T10:06:40.412Z",
            "publishedAt": "2026-06-19T10:06:40.608Z",
            "slug": "general-wille-strasse",
            "Page_Titel": "General-Wille-Strasse 147 - 155, Feldmeilen",
            "Ubersichtstext": "Die Siedlung bietet 27 Wohnungen in unmittelbarer Nähe zum Zürichsee. ",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 813,
            "documentId": "gy5mhqf69t4jvnoelil2cjjt",
            "createdAt": "2026-05-22T12:07:11.574Z",
            "updatedAt": "2026-06-17T12:29:30.965Z",
            "publishedAt": "2026-06-17T12:29:31.106Z",
            "slug": "hardegg-zuerich",
            "Page_Titel": "Hardegg, Zürich",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 815,
            "documentId": "ngbvnfxtyysxknaqr410fw2y",
            "createdAt": "2026-05-08T05:55:54.736Z",
            "updatedAt": "2026-06-17T12:31:36.943Z",
            "publishedAt": "2026-06-17T12:31:37.213Z",
            "slug": "Huettengraben-Kuesnacht",
            "Page_Titel": "Hüttengraben, Küsnacht",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 930,
            "documentId": "ma6y5u7jxh3clsykg2j6w6l7",
            "createdAt": "2026-05-22T12:11:54.486Z",
            "updatedAt": "2026-06-20T06:57:01.802Z",
            "publishedAt": "2026-06-20T06:57:02.683Z",
            "slug": "kaepfnach-rietwies-horgen",
            "Page_Titel": "Käpfnach / Rietwies, Horgen",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 819,
            "documentId": "hvi0vxytch39fpwj1cb4m539",
            "createdAt": "2026-05-22T12:09:59.265Z",
            "updatedAt": "2026-06-17T12:40:33.784Z",
            "publishedAt": "2026-06-17T12:40:33.923Z",
            "slug": "ladenzentrum-zuerich-leimbach",
            "Page_Titel": "Ladenzentrum, Zürich Leimbach",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 877,
            "documentId": "tfxakj9k008m0ftf2yclf0j2",
            "createdAt": "2026-05-22T11:23:54.587Z",
            "updatedAt": "2026-06-19T08:31:35.120Z",
            "publishedAt": "2026-06-19T08:31:35.304Z",
            "slug": "lienihof-zuerich",
            "Page_Titel": "Lienihof, Zürich",
            "Ubersichtstext": "In Zürich-Wollishofen bietet dieser Baukörper 31 individuell geschnittene Wohnungen. Ein nach Süden offener Innenhof schützt vor dem Verkehrslärm. ",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 1031,
            "documentId": "net4mokaac4xaawyvzhwjysg",
            "createdAt": "2026-06-29T05:16:36.169Z",
            "updatedAt": "2026-07-06T05:25:45.433Z",
            "publishedAt": "2026-07-06T05:25:45.641Z",
            "slug": "loogarten-zuerich-altstetten",
            "Page_Titel": "Loogarten, Zürich Altstetten",
            "Ubersichtstext": "Am Suteracher 31 - 39\nEugen-Huber-Strasse 176 - 180\n8048 Zürich",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 952,
            "documentId": "y09toc3picj599ff9xnpcn2c",
            "createdAt": "2026-05-25T05:54:03.670Z",
            "updatedAt": "2026-06-23T05:23:29.207Z",
            "publishedAt": "2026-06-23T05:23:29.435Z",
            "slug": "rautihalde-rautistrasse-zuerich",
            "Page_Titel": "Rautihalde / Rautistrasse, Zürich",
            "Ubersichtstext": "Zwei Wohnhäuser in Hanglage bieten eine weite Sicht über das Quartier bis zum Hönggerberg.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 865,
            "documentId": "s302sduhqmeh5hjrtr7j50l2",
            "createdAt": "2026-05-25T06:05:39.850Z",
            "updatedAt": "2026-06-18T13:34:45.734Z",
            "publishedAt": "2026-06-18T13:34:45.969Z",
            "slug": "roetel-zuerich",
            "Page_Titel": "Rötel, Zürich",
            "Ubersichtstext": "Die Siedlung bietet 76 Wohnungen an zentraler Lage beim Bucheggplatz.",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 933,
            "documentId": "iotnnc52pkd60uc8u14jzu4e",
            "createdAt": "2026-05-25T10:02:35.572Z",
            "updatedAt": "2026-06-20T07:02:40.045Z",
            "publishedAt": "2026-06-20T07:02:40.231Z",
            "slug": "Roetelstrasse-Zuerich",
            "Page_Titel": "Rötelstrasse 117, 119, 121, Zürich",
            "Ubersichtstext": "Drei Gebäude fügen sich zurückversetzt in die Quartierstruktur von Wipkingen ein. ",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 821,
            "documentId": "x2fmrarkd1f8yqzklr89tiu4",
            "createdAt": "2026-05-22T12:12:32.295Z",
            "updatedAt": "2026-06-18T10:52:03.939Z",
            "publishedAt": "2026-06-18T10:52:04.460Z",
            "slug": "schneebeliweg-zuerich",
            "Page_Titel": "Schneebeliweg, Zürich",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 825,
            "documentId": "j5w53h632vcca08jodv6q6dp",
            "createdAt": "2026-05-22T12:07:33.768Z",
            "updatedAt": "2026-06-18T11:00:56.411Z",
            "publishedAt": "2026-06-18T11:00:56.547Z",
            "slug": "sihlweid-zuerich-leimbach",
            "Page_Titel": "Sihlweid, Zürich Leimbach",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 827,
            "documentId": "w4teu5zciqrutg86xlagfj04",
            "createdAt": "2026-05-22T12:12:13.622Z",
            "updatedAt": "2026-06-18T11:09:12.394Z",
            "publishedAt": "2026-06-18T11:09:12.538Z",
            "slug": "stricklerareal-horgen",
            "Page_Titel": "Stricklerareal, Horgen",
            "Ubersichtstext": null,
            "Page_Template": "Pionierprojekte"
        },
        {
            "id": 950,
            "documentId": "h1mkdlrqrr0e7m3deamoz7xu",
            "createdAt": "2026-05-22T07:16:30.923Z",
            "updatedAt": "2026-06-22T11:21:07.507Z",
            "publishedAt": "2026-06-22T11:21:07.711Z",
            "slug": "waldegg-center",
            "Page_Titel": "Waldegg-Center, Horgen",
            "Ubersichtstext": "Das 1984 erbaute Waldegg Center wurde 2012 von der Baugenossenschaft Zurlinden übernommen und in mehreren Etappen sorgfältig saniert. ",
            "Page_Template": "Siedlungen"
        },
        {
            "id": 943,
            "documentId": "ees30dqpkt4b9d8v1w71hu27",
            "createdAt": "2026-05-11T06:59:41.687Z",
            "updatedAt": "2026-06-20T07:59:30.366Z",
            "publishedAt": "2026-06-20T07:59:30.592Z",
            "slug": "zentrum-toedi-horgen",
            "Page_Titel": "Zentrum Tödi, Horgen",
            "Ubersichtstext": "In Horgen entsteht ein lebendiges Quartier mit flexiblen Wohnformen und vielfältigen Nutzungen für Generationen. Aktuell befinden sich die Häuser A + B sowie die TG in Realisation. Das Pflegezentrum ist in Planung. ",
            "Page_Template": "Neubauprojekte"
        }
    ]

    // const getSiedlungen = async () => {
    //     setIsLoading(true)
    //     try {
    //         const response = await fetch("https://backend.bgzurlinden.ch/api/neubauprojekte-posts?pagination[limit]=100&sort[0]=Page_Titel");

    //         const data = await response.json();
    //         console.log("data?.data?.Page_Titel", data?.data);

    //         if (data.data) {
    //             setSiedlungen(data?.data?.filter((item) =>
    //                 item?.Page_Template !==
    //                 "Sanierungen"));
    //         }
    //     }
    //     catch (error) {
    //         console.error(error);
    //     } finally {
    //         setIsLoading(false);
    //     }

    // }

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/parkplatz-form?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Metadaten]=*");


            const data = await response.json();
            console.log('test', data?.data?.Modul);

            if (data.data) {
                setMetaData(data?.data?.Metadaten);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        // getSiedlungen();
        getPageData();
    }, [])

    const [formData, setFormData] = useState({
        liegenschaft: "",
        parkingType: "tiefgarage",
        mietbeginn: "",
        anrede: "",
        firma: "",
        vorname: "",
        nachname: "",
        geburtsdatum: "",
        email: "",
        strasse: "",
        plz: "",
        ort: "",
        telefon: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;

        // Allow only numbers, spaces and +
        if (name === "telefon") {
            newValue = value.replace(/[^0-9+\s]/g, "");
        }

        setFormData((prev) => ({
            ...prev,
            [name]: newValue,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };


    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "liegenschaft",
            "parkingType",
            "mietbeginn",
            "anrede",
            "vorname",
            "nachname",
            "geburtsdatum",
            "email",
            "strasse",
            "plz",
            "ort",
            "telefon",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        if (formData.email && !isValidEmail(formData.email)) {
            newErrors.email = true;
        }

        if (formData.mietbeginn) {
            const error = getMoveInError(formData.mietbeginn);

            if (error) {
                newErrors.mietbeginn = error;
            }
        }

        if (formData.geburtsdatum) {
            const error = getBirthDateError(formData.geburtsdatum);

            if (error) {
                newErrors.geburtsdatum = error;
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");

                if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            });
        });

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, [step]);

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            console.log("Validating select:", name, formData[name], errors[name]);

            if (errors[name] && formData[name].trim() === "") {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border shake");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border shake");
            }
        });
    }, [errors]);

    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("Submitting form with data:", formData);
        // return;

        if (!validateForm()) {

            setTimeout(() => {
                document.querySelectorAll(".warning-border").forEach((el) => {
                    el.classList.remove("shake");

                    // restart animation
                    void el.offsetWidth;

                    el.classList.add("shake");
                });
            }, 0);

            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        try {
            setIsSubmitting(true);

            const response = await fetch(
                `${process.env.REACT_APP_FRONTEND_URL}api/submit-freie-mietobjekte-form?pageTitle=Parkplatz`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            console.log(data);

            if (data?.success) {
                setFormData({
                    liegenschaft: "",
                    parkingType: "tiefgarage",
                    mietbeginn: "",
                    anrede: "",
                    firma: "",
                    vorname: "",
                    nachname: "",
                    geburtsdatum: "",
                    email: "",
                    strasse: "",
                    plz: "",
                    ort: "",
                    telefon: "",
                    message: "",
                });

                setErrors({});

                navigate("/vielen-dank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const validateStep = () => {
        const newErrors = {};

        if (step === 1) {
            const requiredFields = [
                "liegenschaft",
                "parkingType",
                "mietbeginn",
            ];

            requiredFields.forEach((field) => {
                if (!formData[field] || formData[field].trim() === "") {
                    newErrors[field] = true;
                }
            });

            if (formData.email && !isValidEmail(formData.email)) {
                newErrors.email = true;
            }

            if (formData.mietbeginn) {
                const error = getMoveInError(formData.mietbeginn);

                if (error) {
                    newErrors.mietbeginn = error;
                }
            }

            if (formData.geburtsdatum) {
                const error = getBirthDateError(formData.geburtsdatum);

                if (error) {
                    newErrors.geburtsdatum = error;
                }
            }
        }

        if (step === 2) {
            const requiredFields = [
                "anrede",
                "vorname",
                "nachname",
                "geburtsdatum",
                "email",
                "strasse",
                "plz",
                "ort",
                "telefon",
            ];

            requiredFields.forEach((field) => {
                if (!formData[field] || formData[field].trim() === "") {
                    newErrors[field] = true;
                }
            });

            if (formData.email && !isValidEmail(formData.email)) {
                newErrors.email = true;
            }

            if (formData.mietbeginn) {
                const error = getMoveInError(formData.mietbeginn);

                if (error) {
                    newErrors.mietbeginn = error;
                }
            }

            if (formData.geburtsdatum) {
                const error = getBirthDateError(formData.geburtsdatum);

                if (error) {
                    newErrors.geburtsdatum = error;
                }
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const nextStep = (e) => {
        e.preventDefault();

        const isValid = validateStep();

        if (!isValid) {

            setTimeout(() => {
                document.querySelectorAll(".warning-border").forEach((el) => {
                    el.classList.remove("shake");

                    // restart animation
                    void el.offsetWidth;

                    el.classList.add("shake");
                });
            }, 0);

            return;
        }

        setStep((prev) => prev + 1);
    };

    const prevStep = (e) => {
        e.preventDefault();
        setStep((prev) => prev - 1);
    };

    useEffect(() => {
        if (window.innerWidth >= 480) return;

        const element = document.getElementById("step-form-id");

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [step]);


    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 600);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getMoveInError = (value) => {
        if (!value) return "";

        const regex = /^(\d{2})\.(\d{2})\.(\d{4})$/;

        if (!regex.test(value))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const parsed = parse(value, "dd.MM.yyyy", new Date());

        if (!isValid(parsed))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        if (format(parsed, "dd.MM.yyyy") !== value)
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        parsed.setHours(0, 0, 0, 0);

        if (parsed < today)
            return "Das Einzugsdatum muss in der Zukunft liegen";

        return "";
    };

    const getBirthDateError = (value) => {
        if (!value) return "";

        const regex = /^(\d{2})\.(\d{2})\.(\d{4})$/;

        if (!regex.test(value))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const parsed = parse(value, "dd.MM.yyyy", new Date());

        if (!isValid(parsed))
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        if (format(parsed, "dd.MM.yyyy") !== value)
            return "Bitte geben Sie ein gültiges Datum im Format tt.mm.jjjj ein";

        const minBirthDate = subYears(new Date(), 18);

        if (parsed > minBirthDate)
            return "Sie müssen mindestens 18 Jahre alt sein";

        return "";
    };

    return (
        <div className="pt-10">
            <div className="row">
                {/* Steps */}
                <div className="col-md-4 mb-4">
                    <div className="step-sidebar">
                        {[1, 2].map((item) => (
                            <div key={item} className={`step-item ${step >= item ? "active" : ""}`} style={{ color: step == item ? 'var(--orange)' : 'unset' }}>
                                <h3 className="fs_30 fw-600 mb-0">
                                    {item === 1 && "Gewünschter Parkplatz"}
                                    {item === 2 && "Persönliche Angaben"}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
                {/* Form Content */}
                <div className="col-md-8">
                    <form onSubmit={handleSubmit}>
                        <div className="step-form-wraper p-md-4">
                            {step === 1 && (
                                <>
                                    <div className='row'>
                                        <h4 className='fs_26 fw-450 text-darkgrey mb-4'>Name der BGZ Liegenschaft *</h4>
                                        <div className='col-md-6 form-group'>
                                            <select
                                                className="form-control select2"
                                                name="liegenschaft"
                                                value={formData?.liegenschaft || ""}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" disabled>
                                                    Bitte auswählen
                                                </option>

                                                {(siedlungen || []).map((item, index) => (
                                                    <option key={index} value={item.Page_Titel}>
                                                        {item.Page_Titel}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='col-sm-6 form-group position-relative'>
                                            {!isMobile ? (
                                                <DatePicker
                                                    selected={
                                                        formData.mietbeginn
                                                            ? parse(formData.mietbeginn, "dd.MM.yyyy", new Date())
                                                            : null
                                                    }
                                                    onChange={(date) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            mietbeginn: date ? format(date, "dd.MM.yyyy") : "",
                                                        }));

                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            mietbeginn: false,
                                                        }));
                                                    }}
                                                    locale="de"
                                                    dateFormat="dd.MM.yyyy"
                                                    placeholderText="Mietbeginn *"
                                                    className={`form-control ${errors.mietbeginn ? "warning-border shake" : ""}`}
                                                    isClearable
                                                    minDate={new Date()}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="Mietbeginn *"
                                                    value={formData.mietbeginn}
                                                    className={`form-control ${errors.mietbeginn ? "warning-border shake" : ""}`}
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        let value = e.target.value.replace(/\D/g, "");

                                                        if (value.length > 2)
                                                            value = value.slice(0, 2) + "." + value.slice(2);

                                                        if (value.length > 5)
                                                            value = value.slice(0, 5) + "." + value.slice(5);

                                                        if (value.length > 10)
                                                            value = value.slice(0, 10);

                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            mietbeginn: value,
                                                        }));
                                                    }}
                                                />
                                            )}
                                            {!formData.mietbeginn && <img className='calender-icon' src="images/calender-icon-bgz2.svg" alt="" />}
                                            {errors.mietbeginn && (
                                                <small className="" style={{ color: "var(--orange)" }}>
                                                    {errors.mietbeginn}
                                                </small>
                                            )}
                                        </div>
                                        <div className='col-md-12 form-group'>
                                            <h4 className='fs_26 fw-450 text-darkgrey mb-4 mt-3'>Wahl des Parkplatztyps *</h4>
                                            <div className="radio-group">
                                                <label className="radio-item">
                                                    <input
                                                        type="radio"
                                                        name="parkingType"
                                                        value="tiefgarage"
                                                        checked={formData.parkingType === "tiefgarage"}
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className="custom-radio"></span> Tiefgarage
                                                </label>
                                                <label className="radio-item">
                                                    <input
                                                        type="radio"
                                                        name="parkingType"
                                                        value="aussenparkplatz"
                                                        checked={formData.parkingType === "aussenparkplatz"}
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className="custom-radio"></span> Aussenparkplatz
                                                </label>
                                                <label className="radio-item">
                                                    <input
                                                        type="radio"
                                                        name="parkingType"
                                                        value="elektroparkplatz"
                                                        checked={formData.parkingType === "elektroparkplatz"}
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className="custom-radio"></span> Elektroparkplatz
                                                </label>
                                                <label className="radio-item">
                                                    <input
                                                        type="radio"
                                                        name="parkingType"
                                                        value="motorrad"
                                                        checked={formData.parkingType === "motorrad"}
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className="custom-radio"></span> Motorrad
                                                </label>
                                            </div>
                                            {/* <div className="radio-group">
                                                
                                            </div> */}
                                        </div>

                                    </div>
                                </>
                            )}
                            {step === 2 && (
                                <>
                                    <div className='row'>
                                        <div className='col-12 form-group'>
                                            <h4 className='fs_26 fw-450 text-darkgrey'>Anrede *</h4>
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <select
                                                className={`form-control select2`}
                                                name="anrede"
                                                value={formData.anrede}
                                                onChange={handleInputChange}
                                            >
                                                <option value="" className="placeholder" disabled>
                                                    Bitte auswählen
                                                </option>

                                                <option value="Frau">Frau</option>
                                                <option value="Herr">Herr</option>
                                            </select>
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Firma"
                                                name="firma"
                                                value={formData.firma}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.vorname ? "warning-border shake" : ""}`}
                                                placeholder="Vorname *"
                                                name="vorname"
                                                value={formData.vorname}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.nachname ? "warning-border shake" : ""}`}
                                                placeholder="Nachname *"
                                                name="nachname"
                                                value={formData.nachname}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.strasse ? "warning-border shake" : ""}`}
                                                placeholder="Strasse + Nr. *"
                                                name="strasse"
                                                value={formData.strasse}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.plz ? "warning-border shake" : ""}`}
                                                placeholder="PLZ *"
                                                name="plz"
                                                value={formData.plz}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.ort ? "warning-border shake" : ""}`}
                                                placeholder="Ort *"
                                                name="ort"
                                                value={formData.ort}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="tel"
                                                inputMode="numeric"
                                                className={`form-control ${errors.telefon ? "warning-border shake" : ""}`}
                                                placeholder="Telefon *"
                                                name="telefon"
                                                value={formData.telefon}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-group position-relative'>
                                            {!isMobile ? (
                                                <DatePicker
                                                    selected={
                                                        formData.geburtsdatum
                                                            ? parse(formData.geburtsdatum, "dd.MM.yyyy", new Date())
                                                            : null
                                                    }
                                                    onChange={(date) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            geburtsdatum: date
                                                                ? format(date, "dd.MM.yyyy")
                                                                : "",
                                                        }));

                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            geburtsdatum: false,
                                                        }));
                                                    }}
                                                    locale="de"
                                                    dateFormat="dd.MM.yyyy"
                                                    placeholderText="Geburtsdatum *"
                                                    className={`form-control ${errors.geburtsdatum ? "warning-border shake" : ""
                                                        }`}
                                                    isClearable
                                                    maxDate={subYears(new Date(), 18)}
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="Geburtsdatum *"
                                                    value={formData.geburtsdatum}
                                                    className={`form-control ${errors.geburtsdatum ? "warning-border shake" : ""}`}
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        let value = e.target.value.replace(/\D/g, "");

                                                        if (value.length > 2)
                                                            value = value.slice(0, 2) + "." + value.slice(2);

                                                        if (value.length > 5)
                                                            value = value.slice(0, 5) + "." + value.slice(5);

                                                        if (value.length > 10)
                                                            value = value.slice(0, 10);

                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            geburtsdatum: value,
                                                        }));

                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            geburtsdatum: false,
                                                        }));
                                                    }}
                                                />
                                            )}
                                            {!formData.geburtsdatum && <img className='calender-icon' src="images/calender-icon-bgz2.svg" alt="" />}
                                            {errors.geburtsdatum && (
                                                <small className="" style={{ color: "var(--orange)" }}>
                                                    {errors.geburtsdatum}
                                                </small>
                                            )}
                                        </div>
                                        <div className='col-sm-6 form-group'>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.email ? "warning-border shake" : ""}`}
                                                placeholder="E-Mail *"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-12 form-group'>
                                            <textarea
                                                rows={5}
                                                className="form-control"
                                                placeholder="Ihre Mitteilung"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className='col-sm-6 form-captcha'>
                                            <div className='col-sm-6 form-captcha'>
                                                <div className='google_recaptcha'>
                                                    <Turnstile
                                                        siteKey="0x4AAAAAADt5N15MzxPtrdSe"
                                                        onSuccess={(token) => {
                                                            setCaptchaToken(token);
                                                            setCaptchaError(false);
                                                        }}
                                                        onExpire={() => {
                                                            setCaptchaToken("");
                                                        }}
                                                    />

                                                    {captchaError && (
                                                        <p
                                                            style={{
                                                                color: "red",
                                                                marginTop: "10px",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            Bitte bestätigen Sie das Captcha.
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className={`d-flex ${step === 1 ? 'justify-content-end' : 'justify-content-between'} mt-4`}>
                                <button type="button" className={`step_back_btn ${step === 1 ? 'd-none' : ''}`} onClick={prevStep} disabled={step === 1}>
                                    <svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.7369 0.311788C11.1725 -0.103929 11.8787 -0.103924 12.3143 0.311788C12.7499 0.727507 12.7499 1.40153 12.3143 1.81725L2.69274 11L12.3143 20.1828C12.7499 20.5985 12.7499 21.2725 12.3143 21.6882C11.8787 22.1039 11.1725 22.1039 10.7369 21.6882L0.326683 11.7527C-0.108895 11.337 -0.108899 10.663 0.326683 10.2473L10.7369 0.311788Z" fill="#F18300" />
                                        <path d="M27.8846 9.93548C28.5006 9.93548 29 10.4121 29 11C29 11.5879 28.5006 12.0645 27.8846 12.0645L1.11538 12.0645C0.499373 12.0645 -2.02077e-06 11.5879 -1.91798e-06 11C-1.81518e-06 10.4121 0.499373 9.93548 1.11538 9.93548L27.8846 9.93548Z" fill="#F18300" />
                                    </svg>
                                    zurück </button>
                                {step < 2 ? (
                                    <button type="button" className="button round_btn btn-orange-color" onClick={nextStep}> weiter
                                        <span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit"></path><path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit"></path></svg></span>
                                    </button>
                                ) : (
                                    <button type="submit" className="button round_btn btn-orange-color"> absenden
                                        <span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit"></path><path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit"></path></svg></span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ParkplatzStepForm;